import ReportService from "../../service/ReportService";
//import swal from 'sweetalert'

export const namespaced = true

export const state = {
    reportsLoading: false,
    reports: [],
    response: {}
}


export const getters = {
}


export const mutations = {
    updateReports: (state, payload) =>{
        state.reports = payload
    },
    updateReportsLoading: (state, payload) =>{
        state.reportsLoading = payload
    },
}


export const actions = {
    readReports: ({ commit }, payload)=>{
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        commit("updateReportsLoading", true);
        return ReportService.callGenerateReportApi(payload)
            .then(response => {
                commit("updateReportsLoading", false)
                if (response.data.responseCode === "00") {
                    const options = {title: 'Success!', size: 'sm'};
                    dialogs.alert(response.data.responseMessage, options)
                        .then(res => {
                            console.log(res)
                        });
                }else{
                    const options = {title: 'Error!', size: 'sm'};
                    dialogs.alert(response.data.responseMessage, options)
                        .then(res => {
                            console.log(res)
                        });
                }

            })
            .catch(error => {
                commit("updateReportsLoading", false)
                alert(error)
            });
    },
    reset: ({ commit }, payload)=>{
        commit("reset",payload)
    }
}
